<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :before-close="close"
    :modal-append-to-body="false"
    width="600px"
    center
    :title="$t('Audiences_RollingSegment_Destination_FullSyncDialog_Title')"
  >
    <p>
      {{
        $t('Audiences_RollingSegment_Destination_FullSyncDialog_Description')
      }}
    </p>

    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        :loading="loading"
        @click="syncDestination"
        data-qa="fully-sync-confirm"
      >
        {{ $t('Audiences_RollingSegment_Destination_FullSyncDialog_Sync') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'FullSyncDialog',
  props: {
    destination: Object
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    syncDestination() {
      this.loading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `rolling-segment-destination/full-sync`,
          data: {
            segment_id: this.$route.query.id,
            destination_id: this.destination.id
          }
        })
      )
        .then(({ data }) => {
          this.loading = false
          this.$router.push(
            projectRoute({
              name: 'TaskHistoryView',
              query: { id: data.id }
            })
          )
        })
        .catch(error => {
          this.loading = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>

<style scoped>
p {
  font-size: 16px;
  text-align: center;
  word-break: keep-all;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/FullSyncDialog.vue